import { Row, Col, Navbar } from "@/utils/bootstrap";
import SvgFilterGoback from "./SvgFilterGoback";

interface Props {
  title: string;
}
const FilterHeader: React.FC<Props> = ({ title }) => {
  const navHeight = 58;
  return (
    <>
      <div style={{ height: navHeight }} />
      <Navbar
        fixed="top"
        style={{
          height: navHeight,
          boxShadow: "0px 4px 16px rgba(4, 4, 4, 0.05)",
        }}
        className="mobile-header"
      >
        <Row className="m-0 w-100">
          <Row xs={12} className="w-100 m-0 p-0 d-flex align-items-center">
            <Col xs={4} className={`p-0 d-flex align-items-center`}>
              <SvgFilterGoback />
            </Col>
            <Col xs={4} className="text-center p-0 ">
              <div>{title}</div>
            </Col>
            <Col
              xs={4}
              className="p-0 d-flex justify-content-end"
              style={{ gap: 12 }}
            ></Col>
          </Row>
        </Row>
      </Navbar>
    </>
  );
};

export default FilterHeader;
